import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { TranslationKeysMapper } from '@nimbus-library/features/localization/models/translation-keys.model';

export enum SearchOptions {
  Company = 'company',
  Department = 'department',
  JobTitle = 'jobTitle', // User.Read.All
  Assistant = 'assistant', // $expand=directReports && User.Read.All
  Manager = 'manager', // $expand=manager && User.Read.All
  StreetAddress = 'streetAddress', // User.Read.All
  Location = 'location',
  PostalCode = 'postalCode',
  City = 'city',
  State = 'state',
  Country = 'country',
  AccountEnabled = 'accountEnabled',
  Initials = 'initials', // Nimbus Internal
  Note = 'note', // Nimbus Internal
}

export const searchOptionsTranslationKeys: TranslationKeysMapper<SearchOptions> = {
  assistant: TranslationKeys.ContactSearchFilterAssistant,
  city: TranslationKeys.ContactSearchFilterCity,
  company: TranslationKeys.ContactSearchFilterCompany,
  country: TranslationKeys.ContactSearchFilterCountry,
  department: TranslationKeys.ContactSearchFilterDepartment,
  jobTitle: TranslationKeys.ContactSearchFilterJobTitle,
  location: TranslationKeys.ContactSearchFilterLocation,
  manager: TranslationKeys.ContactSearchFilterManager,
  postalCode: TranslationKeys.ContactSearchFilterPostalCode,
  state: TranslationKeys.ContactSearchFilterState,
  streetAddress: TranslationKeys.ContactSearchFilterStreetAddress,
  accountEnabled: TranslationKeys.ContactSearchFilterAccountEnabled,
  initials: TranslationKeys.ContactSearchFilterInitials,
  note: TranslationKeys.ContactSearchFilterNote,
};

export const originalNamesMapper: Record<SearchOptions, string> = {
  assistant: 'Assistant',
  city: 'City',
  company: 'Company',
  country: 'Country',
  department: 'Department',
  jobTitle: 'Job Title',
  location: 'Location',
  manager: 'Manager',
  postalCode: 'Postal Code',
  state: 'State',
  streetAddress: 'Street Address',
  accountEnabled: 'Account Enabled',
  initials: 'Initials',
  note: 'Note',
};
